import { render, staticRenderFns } from "./SecurityService.vue?vue&type=template&id=78841992&scoped=true"
import script from "./SecurityService.vue?vue&type=script&lang=js"
export * from "./SecurityService.vue?vue&type=script&lang=js"
import style0 from "./SecurityService.vue?vue&type=style&index=0&id=78841992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78841992",
  null
  
)

export default component.exports